export const FEATURES = {
  T2T_MIGRATION: 'T2T_MIGRATION',
} as const;

export function hasFeatureClaim(account: unknown, featureKey: string): boolean {
  const source = (account as { idTokenClaims?: unknown; tokenClaims?: unknown } | null) ?? null;
  const claims = (source?.idTokenClaims ?? source?.tokenClaims ?? {}) as Record<string, unknown>;
  const normalizedFeatureKey = featureKey.toUpperCase();

  for (const [key, value] of Object.entries(claims)) {
    if (key.toLowerCase() === `tc-cap:${featureKey.toLowerCase()}` && String(value).toLowerCase() === 'true') {
      return true;
    }
  }

  const possibleFeatureClaims = [
    claims.features,
    claims.feature,
    claims.capabilities,
    claims.tc_caps,
    claims[`tc-cap:${featureKey}`],
  ];

  return possibleFeatureClaims.some((value) => {
    if (Array.isArray(value)) {
      return value.some((x) => String(x).trim().toUpperCase() === normalizedFeatureKey);
    }

    if (typeof value === 'string') {
      return value
        .split(/[\s,;]+/)
        .map((x) => x.trim().toUpperCase())
        .includes(normalizedFeatureKey);
    }

    return false;
  });
}